import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_LISTING_RECEIVE,
  PRODUCT_LISTING_SET_PROP,
  PRODUCT_LISTING_SET_IS_LOADING,
  PRODUCT_LISTING_SET_PRODUCTS,
} from '../constants';
import { AnyAction } from 'redux';
import { ReactElement } from 'react';

export enum ProductListingType {
  Grid = 'Grid',
  List = 'List',
  SingleCard = 'SingleCard',
}

export interface ProductListingState {
  canLoadMore: boolean;
  pageSize: number;
  products: any[]; // TODO ProductItem interface
  productsPerRow: number;
  productListingType: ProductListingType;
  productCardHeight: number;
  totalProductsCount: number;
  isLoadingMore: boolean;
  isLoadingReverse: boolean;
  isLoading: boolean;
  location?: string;
  pageNumberForCrawler: number;
  ProductComponent?: ReactElement;
  ProductPlaceholderComponent?: ReactElement;
  gtmViewModel?: any;
}

const defaultState: ProductListingState = {
  canLoadMore: true,
  pageSize: 12,
  products: [],
  productsPerRow: 4,
  productListingType: ProductListingType.Grid,
  productCardHeight: 505,
  totalProductsCount: 0,
  isLoadingMore: false,
  isLoadingReverse: false,
  isLoading: false,
  pageNumberForCrawler: 0,
};

export const productListing = (
  state = defaultState,
  action: AnyAction
): ProductListingState => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_LISTING_RECEIVE:
    case PRODUCT_LISTING_SET_PROP:
    case PRODUCT_LISTING_SET_IS_LOADING:
    case PRODUCT_LISTING_SET_PRODUCTS:
      return {
        ...state,
        ...payload,
      };
    case PRODUCT_FILTERING_RECEIVE:
      return {
        ...state,
        ...payload.productListing,
      };
    default:
      return state;
  }
};
